import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import DialogIcon from '@/images/Dialog.svg';
import { theme } from '@de-id/ui-components';
import styled from '@emotion/styled';

const NoDataContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 16px;

    color: ${theme.colors.secondary.main};
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    padding: 72px 0;
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: rgba(92, 92, 92, 0.08);
`;

export const TableNoData = () => {
    return (
        <NoDataContainer>
            <IconWrapper>
                <MaskedIcon src={DialogIcon} size="24px" />
            </IconWrapper>
            No user activity data available yet
        </NoDataContainer>
    );
};
